import {RoundStatus} from "modules/enums";
import {createAction} from "redux-act";

export const getRoundsJson = createAction();

export interface IRound {
	id: number;
	status: RoundStatus;
	date: Date;
	contestId: string;
}

export const getRoundsJsonSuccess = createAction<IRound[]>();
export const getRoundsJsonFailed = createAction();
